<!-- One Hi-Vis icon (icons.ts), in currentColor. Decorative unless labelled. -->
<template>
  <!-- eslint-disable vue/no-v-html -- constant path data from icons.ts, never user text -->
  <svg
    class="hv-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    focusable="false"
    v-html="HV_ICONS[name] ?? ''"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import { HV_ICONS } from './icons';
withDefaults(defineProps<{ name: string; size?: number; stroke?: number; label?: string }>(), { size: 24, stroke: 2 });
</script>

<style scoped>
.hv-icon { flex: none; display: block; }
</style>
